@if (countryCode === 'AT') {
  <app-phonenumber-port-at
    (selected)="selected.emit($event)"
    (onBack)="back.emit()"
  ></app-phonenumber-port-at>
}
@if (countryCode === 'DE') {
  <app-phonenumber-port-de
    (selected)="selected.emit($event)"
    (onBack)="back.emit()"
  ></app-phonenumber-port-de>
}
